import { ACTION_CASHOUT_HISTORY_ERROR, ACTION_CASHOUT_HISTORY_SUCCESS, ACTION_REWARD_HISTORY, ACTION_REWARD_HISTORY_ERROR, ACTION_REWARD_HISTORY_SUCCESS } from "../actions";

const initState = {
    isLoading: false,
    erro_msg: undefined,
    data: undefined
}


export const getRewardHistoryReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_REWARD_HISTORY:
            return { ...state, isLoading: true, erro_msg: undefined }
        case ACTION_REWARD_HISTORY_SUCCESS:
            return { ...state, isLoading: false, erro_msg: undefined, data: action.payload.data }
        case ACTION_REWARD_HISTORY_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        default:
            return state;
    }
}